// PT-BR
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Preços dinâmicos",
    prices: "Preços",
    noPropertiesAvailable: "Nenhuma propriedade disponível",
    noPropertiesFound: "Nenhuma propriedade encontrada",
    minStayShort: "mín. {n}n",
    available: "Disponível",
    closed: "Fechado",
    loading: "Carregando…",
    showMoreMonths: "Mostrar mais meses",
    from: "De",
    to: "Até",
    nightsLabelOne: "{n} noite",
    nightsLabelMany: "{n} noites",
    whatToDo: "O que você quer fazer?",
    close: "Fechar",
    open: "Abrir",
    price: "Preço",
    minStay: "Estadia mín.",
    closeReasonPlaceholder: "Motivo do fechamento (opcional)",
    openHint: "As datas selecionadas serão reabertas (o bloqueio é removido).",
    nightsWord: "noites",
    clearSelection: "Limpar seleção",
    past: "Passada",
    guestOne: "hóspede",
    guestMany: "hóspedes",
    perNight: "/ noite",
    noName: "Sem nome",
    channelDirect: "Direta",
    ownerBlockComment: "Bloqueio pelo proprietário",
    prepTime: "Tempo de preparação",
    sameDayCutoff: "Fechamento no mesmo dia",
    linkedClosed: "Venda completa",
    linkedClosedInfo: "Fechado pela venda do apartamento inteiro ({motivo}). Reabrirá sozinho se essa reserva for cancelada ou mudar de datas.",
    alsoLinked: "também fechado pela venda do apartamento inteiro ({motivo})",
    applyClose: "Fechar datas",
    applyOpen: "Abrir datas",
    applyPrice: "Salvar preço",
    applyMinStay: "Salvar estadia mínima",
    apply: "Aplicar",
    processing: "Processando…",
    closingDates: "Fechando datas…",
    openingDates: "Abrindo datas…",
    priceModeLabel: "Forma de preço",
    priceModeFixed: "Fixo",
    priceModePercent: "%",
    priceModeAmount: "Valor",
    percentPlaceholder: "Ex. 20",
    amountPlaceholder: "Ex. 10",
    percentHint: "Cada noite é recalculada sobre o seu preço. Com − baixa.",
    amountHint: "Soma-se ao que cada noite já custa. Com − baixa.",
    invalidPrice: "Insira um preço válido.",
    changingPrice: "Alterando preço por noite…",
    priceUpdated: "Preço atualizado com sucesso.",
    priceUpdateError: "Não foi possível atualizar o preço.",
    minStayMin: "A estadia mínima deve ser de pelo menos 1 noite.",
    changingMinStay: "Alterando estadia mínima…",
    minStayUpdated: "Estadia mínima atualizada com sucesso.",
    minStayUpdateError: "Não foi possível atualizar a estadia mínima.",
    unknownError: "Erro desconhecido",
  },
  calendar: {
    channelDirect: "Direta",
    searchMin2: "Digite pelo menos 2 caracteres para buscar",
    searchNoResults: "Nenhuma reserva encontrada para essa busca",
    searchError: "Erro ao buscar reservas",
    processing: "Processando…",
    ownerBlockComment: "Bloqueio pelo proprietário",
    cutoffTip: "Fechamento de vendas no mesmo dia às {time}",
    nightsLabelOne: "{n} noite",
    nightsLabelMany: "{n} noites",
    turnoverBefore: "Tempo de preparação: bloqueie {nights} antes de cada entrada",
    turnoverAfter: "Tempo de preparação: bloqueie {nights} a partir de cada saída",
    turnoverBoth: "Tempo de preparação: bloqueie {nights} antes da entrada e a partir da saída",
    selectAtLeastOneProperty: "Selecione pelo menos uma propriedade.",
    selectAtLeastOneDate: "Selecione pelo menos uma data efetiva para aplicar as alterações.",
    preparingOps: "Preparando {total} operações...",
    applyingOps: "Aplicando {index} de {total}: {name}",
    unknownError: "Erro desconhecido",
    couldNotSaveChanges: "Não foi possível salvar as alterações.",
    bulkApplyError: "Não foi possível aplicar as alterações em massa. {message}",
    opsApplied: "{success} de {total} operações foram aplicadas.",
    opsSkipped: "{skipped} datas com reservas confirmadas foram ignoradas.",
    opsFailed: "{failed} operações falharam.",
    bulkApplied: "Edição em massa aplicada em {count} propriedades.",
    couldNotOpenDate: "Não foi possível abrir a data",
    datesOpened: "Datas abertas",
    closeUpdated: "Bloqueio atualizado",
    todayLabel: "Hoje",
    closed: "Fechado",
    linkedClosed: "Venda completa",
    linkedClosedInfo: "Fechado pela venda do apartamento inteiro ({motivo}). Reabrirá sozinho se essa reserva for cancelada ou mudar de datas.",
    alsoLinked: "também fechado pela venda do apartamento inteiro ({motivo})",
    closingDates: "Fechando datas…",
    couldNotCloseDates: "Não foi possível fechar as datas",
    clearFiltersTitle: "Limpar filtros",
    noPropertiesAvailable: "Nenhuma propriedade disponível",
    noPropertiesFound: "Nenhuma propriedade encontrada",
    dynamicPricesTitle: "Preços dinâmicos",
    prices: "Preços",
    viewWide: "Visualização ampla",
    viewCompact: "Visualização compacta",
    viewNormal: "Visualização normal",
    viewFull: "Ver completo",
    searchBookingTitle: "Buscar reserva",
    searchBookingPlaceholder: "Buscar reserva…",
    search: "Buscar",
    resultsSelectOne: "{count} resultados — selecione um:",
    bulkEdit: "Edição em massa",
    goToTodayTitle: "Ir para hoje",
    showHeader: "Mostrar cabeçalho",
    configArrivalDeparture: "Configurar regras de chegada e saída",
    notAvailable: "Indisponível",
    extension: "Extensão",
    lateCheckoutUntil: "Saída tardia até às {time}",
    aiRequests: "Receção IA",
    guestComments: "Observações do hóspede",
    internalNotes: "Notas internas",
    extrasTitle: "Extras contratados",
    extrasPending: "Aguardando confirmação",
    reqArrivalTitle: "Hora de chegada",
    reqAt: "às {time}",
    reqUntil: "até às {time}",
    reqNights: "Noites extra: {n}",
    reqPending: "Pendente",
    reqConfirmed: "Confirmada",
    reqPaid: "Paga",
    reqOffered: "Oferecida",
    reqPrioritised: "Priorizada",
    pendingAmount: "Pendente:",
    noticesColumn: "Avisos",
    callsTitle: "Chamadas",
    callsCount: "Chamadas: {n}",
    extensionPaid: "Extensão paga",
    listCheckin: "Entrada",
    listCheckout: "Saída",
    priceOriginal: "Reserva original",
    priceExtension: "Extensão",
    priceTotal: "Total",
    paymentInProcess: "Pagamento em andamento",
    overbooking: "Overbooking",
    noAccommodationsFound: `Nenhuma propriedade encontrada com "{term}".`,
    past: "Passada",
    paymentInProcessLower: "pagamento em andamento",
    pendingApproval: "pendente de aprovação",
    pendingApprovalTitle: "Pendente de aprovação",
    guestOne: "hóspede",
    guestMany: "hóspedes",
    perNight: "/ noite",
  },
  tableFilters: {
    filterByDate: "Filtrar por data de - até",
    filterByCountry: "Filtrar por país",
    all: "Todos",
    countrySpain: "Espanha",
    countryColombia: "Colômbia",
    countryBrazil: "Brasil",
    filterByState: "Filtrar por status",
    allStates: "Todos os status",
    stateDemo: "Versão demo",
    stateSubscribed: "Assinantes",
    stateNotSubscribed: "Não assinantes",
    searchRecords: "Buscar nos registros",
  },
  chatbotPageIndex: {
    aiAgentBadge: "Agente IA",
    planFeatureHint: "Recurso disponível com plano pago.",
    otaAgentTitle: "Agente IA para OTAs",
    otaAgentHint: "Ative para que o agente responda automaticamente às mensagens de Booking, Airbnb e outras OTAs.",
    otaRequiresWhatsapp: "Requer o Agente IA do WhatsApp ativo.",
    guardNotice: "Com o Agente IA desativado, o chat também passa para <strong>resposta manual</strong> automaticamente. Os botões por conversa ficarão bloqueados até você reativá-lo.",
    configureBasic: "Configurar agente IA básico",
    configureAdvanced: "Configurar agente IA avançado",
    comingSoon: "Em breve",
    detailFallback: "Detalhe",
    errorLoadListingConfig: "Não foi possível carregar a configuração do anúncio",
    errorSaveChange: "Erro ao salvar a alteração",
    otaAgentActivated: "Agente IA para OTAs ativado",
    otaAgentDeactivated: "Agente IA para OTAs desativado",
  },
  chatbotIndex: {
    accommodationFallback: "Acomodação",
    defaultHandoffSupportLine: "\nSe precisar de atendimento rápido, fale com a gente pelo {phone} 📞",
    defaultHandoffMessage: "Olá 😊 No momento não tenho essa informação, mas um membro da nossa equipe vai atender você em breve 🙌{suffix}\nEstamos à disposição durante toda a sua estadia! 🏡✨",
    silentModeMessage: "Nenhuma resposta automática será enviada ao hóspede. O sistema continuará notificando o operador para que ele possa dar continuidade à conversa.",
    statusNoGuestReply: "Sem resposta ao hóspede",
    statusUsingCustom: "Usando mensagem personalizada",
    statusUsingDefault: "Usando mensagem padrão",
    helperSilent: "O hóspede não receberá resposta automática quando o Agente IA não souber o que responder, mas o operador receberá a notificação para assumir a conversa.",
    helperCustom: "O sistema traduzirá esta mensagem personalizada automaticamente para o idioma do hóspede.",
    helperHasCustom: "Você tem uma mensagem personalizada salva, mas por enquanto o sistema continuará usando a mensagem padrão.",
    helperDefault: "Se você criar uma mensagem mestre, poderá ativá-la aqui e o sistema a traduzirá automaticamente para o idioma do hóspede.",
    sourceSilent: "Silencioso",
    sourceCustom: "Personalizado",
    sourceDefault: "Padrão",
    defaultBotName: "Meu Assistente Virtual",
    errorLoadBotName: "Não foi possível carregar o nome do assistente.",
    errorLoadHandoff: "Não foi possível carregar a mensagem de encaminhamento.",
    botNameUpdated: "Nome do assistente atualizado.",
    errorSaveBotName: "Não foi possível salvar o nome do assistente.",
    masterMessageUpdated: "Mensagem mestre atualizada.",
    errorSaveMaster: "Não foi possível salvar a mensagem mestre.",
    warnCreateCustomFirst: "Crie primeiro uma mensagem personalizada antes de ativá-la.",
    modeCustomActivated: "Agora será usada a mensagem personalizada.",
    modeSilentActivated: "O bot ficará em silêncio quando não souber responder, mas o operador continuará sendo notificado.",
    modeDefaultActivated: "Agora será usada a mensagem padrão.",
    errorUpdateActiveMessage: "Não foi possível atualizar a mensagem ativa.",
    warnWriteQuestion: "Escreva uma pergunta antes de salvar.",
    questionCreated: "Pergunta criada com sucesso.",
    errorAddQuestion: "Não foi possível adicionar a pergunta.",
    botNamePlaceholder: "Nome do assistente",
    handoffRowTitle: "Mensagem quando o agente não sabe responder",
    customize: "Personalizar",
    expandAria: "Expandir",
    handoffSubtitle: "Este texto será enviado quando o Agente IA não encontrar a resposta nos facts, na memória ou nas FAQs.",
    modeDefaultTitle: "Mensagem padrão",
    modeDefaultDesc: "Usa a mensagem padrão do sistema com o telefone de suporte.",
    modeCustomTitle: "Mensagem personalizada",
    modeCustomDescActive: "Ative o texto personalizado que você salvou no modal.",
    modeCustomDescEmpty: "Você ainda não criou uma mensagem personalizada.",
    modeSilentTitle: "Não responder ao hóspede",
    modeSilentDesc: "O hóspede não recebe mensagem automática, mas o operador será notificado para dar continuidade à conversa.",
    loadingMessage: "Carregando mensagem...",
    masterMessage: "Mensagem mestre",
    newQuestionTitle: "Nova pergunta",
    newQuestionSubtitle: "Crie uma nova pergunta frequente para que o Agente IA possa respondê-la com mais precisão.",
    guestQuestionLabel: "Pergunta do hóspede",
    questionPlaceholder: "Ex.: A que horas é o check-in?",
    questionHelp: "Dica: escreva a pergunta como um hóspede real faria.",
    cancel: "Cancelar",
    saveQuestion: "Salvar pergunta",
    handoffKicker: "Resposta de encaminhamento",
    handoffModalTitle: "Personalizar mensagem mestre",
    handoffModalSubtitle: "Escreva uma única mensagem em espanhol. O sistema a traduzirá automaticamente e responderá conforme o idioma que o hóspede estiver falando.",
    masterToolbarInfo: "Você pode usar emojis e um tom próximo, igual às suas outras mensagens automáticas.",
    emojiSearchPlaceholder: "Buscar emoji...",
    masterTextareaPlaceholder: "Escreva aqui a mensagem mestre. Você pode usar emojis e um tom acolhedor para o hóspede.",
    masterHint: "Recomendação: escreva a mensagem em espanhol com o tom exato que você quer transmitir. O sistema a adaptará automaticamente ao idioma do hóspede.",
    viewDefaultMessage: "Ver mensagem padrão",
    saveMessage: "Salvar mensagem",
    newButton: "Nova",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Você está usando a versão demo",
    ofThePlatform: "da plataforma",
    trialHave: "Você ainda tem",
    trialDaysToEnjoy: "dias para aproveitar todas as funcionalidades!",
    trialSubscribeNow: "Assine agora e continue gerenciando suas acomodações sem interrupções.",
    subscribeNowLabel: "Assinar agora",
  },
};
